import React from "react";

function SponserHomeEight({ className }) {
  return (
    <>
      <div className={`appie-signup-area ${className || ""}`}>
        <div className="container mt-50 mb-50 ">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="
                appie-project-3-box
                d-block d-md-flex
                justify-content-between
                align-items-center
                wow
                animated
                fadeInUp
              "
                data-wow-duration="2000ms"
                data-wow-delay="400ms"
              >
                <h5 className="title"> Do you have a project in mind</h5>
                <a className="main-btn" href="mailto:info@universe-media.com">
                  Let’s Talk
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SponserHomeEight;
